module.exports = __webpack_public_path__ + "static/media/tachometer.669a9a47.svg";